export default __webpack_public_path__ + "static/media/knowledge.e30ed25b.png";